import { isProductionEnvironment } from 'src/utils/environment/isProductionEnvironment';

export function isDevelopmentEnvironment(): boolean {
    return !isProductionEnvironment();
}
